export default "__VITE_ASSET__B6haT6U8__"